// @ts-nocheck

import React, { Component } from 'react';
import { navigate } from '../../../lib/routerAdapter';
import qs from 'query-string';
import moment from 'moment';





import {
  formatDateTimeToString,
  getListInitialState,
  setQueryParams } from
'./../../../lib/helpers';

import { Table } from './../../../components/ui';














const COLUMNS = [
{
  title: 'Филиал',
  dataIndex: 'branchName'
},
{
  title: '№ документа',
  dataIndex: 'documentNumber'
},
{
  title: 'Период проведения',
  dataIndex: 'period',
  render: (period) => formatDateTimeToString(period, 'MMMM YYYY')
},
{
  title: 'Подрядчик',
  dataIndex: 'contractor'
},
{
  title: 'Сумма по плану',
  dataIndex: 'actSum'
},
{
  title: 'Сумма по факту',
  dataIndex: 'act.sum'
},
{
  title: 'Отклонение',
  dataIndex: '',
  render: (record) =>
  record.actSum - record.factSum
}];


export class GroupListTable extends Component {
  static defaultProps = {
    location: {}
  };

  state = {
    ...getListInitialState(),
    filter: {}
  };

  componentDidMount() {
    const { page, ...filter } = qs.parse(this.props.location.search);
    this.setState(
      {
        filter: { ...filter },
        page
      },
      () => this.fetch(page)
    );
  }

  getDate(period) {
    const startDate = moment(period).
    startOf('month').
    format();
    const endDate = moment(startDate).
    endOf('month').
    format();
    return { startDate, endDate };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.readOnly !== this.props.readOnly) {
      this.fetch();
    }
  }

  fetch(page = 1) {
    const { filter } = this.state;
    this.setState({ loading: true });
    return { page, onlyNode: true, ...filter };
  }

  applyFilter = (filter) => {
    this.setState({ filter }, () => this.fetch(this.state.page));
  };

  cleanFilter = () => {
    const { nodeId, period } = this.state.filter;
    this.setState({ filter: { nodeId, period } }, () => {
      nodeId && period && setQueryParams({ nodeId, period });
      this.fetch(this.state.page);
    });
  };

  renderFilter(Filter) {
    const { filter } = this.state;
    return (
      <Filter
        filter={filter}
        applyFilter={this.applyFilter}
        cleanFilter={this.cleanFilter} />);


  }

  renderTable(columns = COLUMNS) {
    const { location, path } = this.props;
    const { data, totalCount, pageSize, page, loading } = this.state;
    return (
      <Table
        fetch={this.fetch}
        onRow={({ period, branchId }) => ({
          onClick: () =>
          navigate(
            `/budget/execution${
            path === '/' ? '/maintenance' : path}/month?period=${
            period}&nodeId=${branchId}`
          )
        })}
        pagination={{
          page,
          pageSize,
          totalCount,
          location
        }}
        loading={loading}
        columns={columns}
        data={data} />);


  }
}
